import { render, staticRenderFns } from "./TecInfoProjectBrife.vue?vue&type=template&id=60b17d0a&scoped=true&"
import script from "./TecInfoProjectBrife.vue?vue&type=script&lang=js&"
export * from "./TecInfoProjectBrife.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b17d0a",
  null
  
)

export default component.exports